// extracted by mini-css-extract-plugin
export default {"rating":"Yo0ozOTpgKj4SVaIVx53","stars":"wOQD_dZEoKotWoT5Eyjd","count":"SPYiArJCgyI23KTdR6aR","starContainer":"wfNh8eBgJFA4Q3t3xoyS","star":"xx2qBmXSLufz5Tmp2602"};